import ButtonField from "../buttonField/buttonField";
import { classNameBtn } from "../shared/button/types/buttonProps";
import SelectInput from "../shared/selectInput/selectInput";
import { PaginationProps } from "./types/paginationProps";
import { useState } from "react";
import './pagination.scss';

const sizes = [10, 20, 50, 100].map((pageSize) => (
    { name: `${pageSize}`, value: pageSize }
));
const defaultPageSize = sizes[0];

const Pagination = (props: PaginationProps) => {
    const [selectedPageSize, setSelectedPageSize] = useState(() => {
        if (props.initialPageSize)
        {
            return { name: `${props.initialPageSize}`, value: props.initialPageSize }
        }
        return defaultPageSize;
    });

    return (
        <div className='tableView-pagination'>
            <SelectInput label="" onChange={(opt: any) => {
                const pageSize = Number(opt.value);
                const newPageCount = props.allCount !== undefined ? Math.ceil(props.allCount / pageSize) : 1;

                setSelectedPageSize(opt)

                if (props.setPagination !== undefined && props.pagination !== undefined) {
                    props.setPagination({pageSize: pageSize, pageIndex: 0})
                    if (props.onChange !== undefined) {
                        props.onChange('pageSize', pageSize);
                    }
                }
                if (props.setPageCount !== undefined && props.pageCount !== newPageCount) {
                    props.setPageCount(newPageCount);
                }
            }}
                hasInputTags={false} options={sizes} onlySingleTag={true}
                selectedSingleOption={selectedPageSize} style={{ width: '100px' }}
            />
            <div className="tableView-pagination-btn">
                <span className="tableView-pagination-info">
                    <div>Strona</div>
                    <strong>
                        {props.pagination !== undefined ? props.pagination.pageIndex + 1 : 1} z{' '}
                        {props.pageCount}
                    </strong>
                </span>
                <div><ButtonField BtnProps={{
                    onClick: () => { props.table.setPageIndex(0); },
                    disabled: !props.table.getCanPreviousPage(),
                    className: classNameBtn.SmallSecondary + " body-txt-XL"
                }}
                    placeHolder="<<"
                /></div>
                <div><ButtonField BtnProps={{
                    onClick: () => { props.table.previousPage() },
                    disabled: !props.table.getCanPreviousPage(),
                    className: classNameBtn.SmallSecondary + " body-txt-XL"
                }}
                    placeHolder="<"
                /></div>
                <div><ButtonField BtnProps={{
                    onClick: () => { props.table.nextPage() },
                    disabled: !props.table.getCanNextPage(),
                    className: classNameBtn.SmallSecondary + " body-txt-XL"
                }}
                    placeHolder=">"
                /></div>
                <div><ButtonField BtnProps={{
                    onClick: () => {
                        const pC = props.table.getPageCount();
                        props.table.setPageIndex(pC > 1 ? pC - 1 : 1);
                    },
                    disabled: !props.table.getCanNextPage(),
                    className: classNameBtn.SmallSecondary + " body-txt-XL"
                }}
                    placeHolder=">>"
                /></div>
            </div>
        </div>
    )
}

export default Pagination;